import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@app/app.config';
import { ResponseDtoService } from '@app/shared/services/response-dto.service';
import { CognitoUser } from '@cco/model';
import * as Sentry from '@sentry/browser';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CognitoTokensWithIotConnectionInfo } from '@core/models/cognito-tokens-with-iot-connection-info';

@Injectable({
  providedIn: 'root',
})
export class Auth2Service extends ResponseDtoService {
  readonly relativeUrl: string;

  constructor(@Inject(APP_CONFIG) config: AppConfig, private http: HttpClient) {
    super(config.apiBaseUrl);
    this.relativeUrl = `/security`;
  }

  checkAuthenticationStatus(): Observable<CognitoUser> {
    return this.http.get<CognitoUser>(`${this.baseUrl + this.relativeUrl}/users/current`).pipe(
      tap((user) => {
        Sentry.setUser({
          username: user.username,
          email: user.email,
          id: user.sub,
        });
      }),
    );
  }

  getToken$(aud: string): Observable<string> {
    return this.http.get(`${this.baseUrl + this.relativeUrl}/users/current/token`, {
      params: {
        aud,
      },
      responseType: 'text',
    });
  }

  getIotConnectionInfo$(): Observable<CognitoTokensWithIotConnectionInfo> {
    return this.http.get<CognitoTokensWithIotConnectionInfo>(`${this.baseUrl + this.relativeUrl}/users/current/iot-connection-info`);
  }

  attachIotPolicy(identityId: string): Observable<any> {
    return this.http.put(`${this.baseUrl + this.relativeUrl}/users/current/attach-iot-policy`, { identityId });
  }

  getCognitoFederationToken$(): Observable<string> {
    return this.http.get(`${this.baseUrl + this.relativeUrl}/users/current/cognito-federation-token`, {
      responseType: 'text',
    });
  }
}
